import moment from "moment";
import { Control, Controller } from "react-hook-form";
import { ContractGroupModel, CUSTOM_FIELD_TYPE, CustomFieldModel } from "src/api/contractGroup/contractgroup-type";
import { BaseButton, BaseSelect } from "src/components";
import { BaseDatePicker } from "src/components/BaseDatePicker";
import { BaseInput } from "src/components/BaseInput";
import { MultiSelectValue } from "src/components/multiSelect";
import Link from "src/components/PartnerLink";
import { PagePath } from "src/pages/product/details";
import { isUrl } from "src/utils/common-util";

type Props = {
  customFieldList: CustomFieldModel[];
  control: Control<ContractGroupModel>;
};

const ContractGroupCustomFieldForm = ({ customFieldList, control }: Props) => {
  return (
    <article className="contents-container__wrap-article">
      <div className="contents-container__sub-title">
        <h2>커스텀 필드</h2>
      </div>

      {customFieldList.length > 0 ? (
        customFieldList.map((item, index) => (
          <section className="contents-container__grid" key={item.fieldId}>
            <div className="contents-container__grid-index">
              <p>{item.fieldName}</p>
            </div>
            <div className="contents-container__grid-contents">
              <div className={!(item.fieldType === CUSTOM_FIELD_TYPE.TEXT || item.fieldType === CUSTOM_FIELD_TYPE.URL) ? "minmax240" : ""}>
                {/* RADIO 타입 */}
                {item.fieldType === CUSTOM_FIELD_TYPE.RADIO && (
                  <Controller
                    name={`inputList.${index}.optionList`}
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      //
                      return (
                        <BaseSelect
                          stateOptions={item.optionList?.map((option) => ({ value: option.optionId, label: option.optionName })) || []}
                          menuPosition="fixed"
                          value={value?.find((option: any) => option.registered === true)?.optionId || value?.[0]?.optionId}
                          setStateValue={(value: string) => {
                            onChange([{ optionId: value }]);
                          }}
                          placeholder={`선택해주세요`}
                        />
                      );
                    }}
                  />
                )}

                {/* CHECKBOX 타입 */}
                {item.fieldType === CUSTOM_FIELD_TYPE.CHECKBOX && (
                  <Controller
                    name={`inputList.${index}.optionList`}
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      return (
                        <MultiSelectValue
                          options={item.optionList?.map((option) => ({ value: String(option.optionId), label: option.optionName })) || []}
                          value={value?.map((opt: any) => String(opt.optionId)) || []}
                          onChange={(values) => onChange(values.map((optionId) => ({ optionId: Number(optionId) })))}
                          placeholder="선택해주세요"
                        />
                      );
                    }}
                  />
                )}

                {/* TEXT, NUMBER, URL 타입 */}
                {(item.fieldType === CUSTOM_FIELD_TYPE.TEXT ||
                  item.fieldType === CUSTOM_FIELD_TYPE.NUMBER ||
                  item.fieldType === CUSTOM_FIELD_TYPE.URL) && (
                  <Controller
                    name={`inputList.${index}.inputValue`}
                    control={control}
                    rules={{
                      validate: (value) => {
                        // 빈 값이면 검증 통과
                        if (!value || value.trim() === "") {
                          return true;
                        }

                        if (item.fieldType === CUSTOM_FIELD_TYPE.NUMBER) {
                          return /^\d+$/.test(value) || "숫자만 입력해주세요";
                        }
                        if (item.fieldType === CUSTOM_FIELD_TYPE.URL) {
                          return isUrl(value) || "https:// 또는 http:// 로 시작하는 URL을 입력해주세요";
                        }
                        return true;
                      },
                    }}
                    render={({ field: { onChange, value }, formState: { errors } }) => {
                      //
                      return (
                        <BaseInput
                          onChange={(value: string) => {
                            if (item.fieldType === CUSTOM_FIELD_TYPE.NUMBER) {
                              onChange(value);
                            } else {
                              onChange(value);
                            }
                          }}
                          value={value || ""}
                          placeholder={`입력해주세요`}
                          errorText={errors.inputList?.[index]?.inputValue?.message as string}
                        />
                      );
                    }}
                  />
                )}

                {/* CALENDAR 타입 */}
                {item.fieldType === CUSTOM_FIELD_TYPE.CALENDAR && (
                  <Controller
                    name={`inputList.${index}.inputValue`}
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      return (
                        <BaseDatePicker
                          type="date"
                          setDate={(date: any) => {
                            onChange(moment(date));
                          }}
                          placeholder="날짜설정"
                          // selectedDate={value ? moment(value).toDate() : null}
                          selectedDate={value ? moment(value).toDate() : null}
                          icon
                        />
                      );
                    }}
                  />
                )}
              </div>
            </div>
          </section>
        ))
      ) : (
        <div className="contents-container__grid-contents ">
          <div className="flex-row flex-center-start px20 py30" style={{ backgroundColor: "#f8f8fa", borderRadius: "10px" }}>
            <span>관리하는 계약의 운영 정보를 만들어 관리할 수 있어요.</span>
            <Link target="_blank" to={PagePath.contractGroup.customField}>
              <BaseButton className="color-white ml10" title="커스텀 필드 관리" />
            </Link>
          </div>
        </div>
      )}
    </article>
  );
};

export default ContractGroupCustomFieldForm;
